import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({
  chapter,
  eyebrow,
  title,
  subtitle,
  align = "left",
  testId,
}) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p
        className={`flex items-center gap-4 ${
          align === "center" ? "justify-center" : ""
        }`}
      >
        <span className="font-display text-xs font-bold tracking-[0.4em] text-gold">
          {chapter}
        </span>
        <span className="h-px w-10 bg-gold/50" aria-hidden="true" />
        <span className="font-serif text-lg italic text-bone/60">{eyebrow}</span>
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        data-testid={testId}
        className="mt-6 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-bone sm:text-4xl lg:text-5xl"
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base leading-relaxed text-bone/60 md:text-lg">
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
